@if (productCode && isLoggedIn$ | async) {
  <form class="add-to-cart" [formGroup]="addToCartForm" (submit)="addToCart()">
    @if (uomSelectOptions && uomSelectOptions.length > 0) {
      <div class="add-to-cart__uom">
        <label>Unit of measurement </label>
        @if (uomSelectOptions && uomSelectOptions.length > 1) {
          <ng-select
            [tabIndex]="0"
            [placeholder]="uomSelected.title"
            class="add-to-cart__uom__dropdown"
            [items]="uomSelectOptions"
            bindLabel="title"
            [searchable]="false"
            [clearable]="false"
            (change)="onUomSelected($event)"
            [(ngModel)]="uomSelected"
            [ngModelOptions]="{ standalone: true }"
            >
          </ng-select>
        }
        @if (uomSelectOptions && uomSelectOptions.length === 1) {
          <p>{{ uomSelectOptions[0].title }}</p>
        }
        @if (uomSelected.message && uomSelected.message.length > 0) {
          <span class="add-to-cart__uom__message">
            {{ uomSelected.message }}
          </span>
        }
      </div>
    }
    @if (showQuantity) {
      <div class="quantity">
        <label>{{ 'addToCart.quantity' | cxTranslate }}</label>
        <cx-item-counter [max]="maxQuantity" [control]="addToCartForm.get('quantity')"></cx-item-counter>
        <span class="info" [ngClass]="getStockColor">
          {{ 'addToCart.' + product?.stock?.stockLevelStatus | cxTranslate }}
        </span>
        <i
          class="stock-icon fas"
          [ngClass]="[getStockColor, getStockIcon]"
          [title]="'addToCart.' + product?.stock?.stockLevelStatus | cxTranslate"
          [attr.aria-label]="'addToCart.' + product?.stock?.stockLevelStatus | cxTranslate"
        ></i>
      </div>
    }
    @if (userPermissionService.addToCart) {
      <button
        class="btn {{ buttonClass }} btn-primary btn-block border-0"
        type="submit"
        [disabled]="quantity <= 0 || !price || discontinuedProduct(product)"
        >
        {{ 'addToCart.addToCart' | cxTranslate }}
      </button>
    }
  </form>
}
